/* GLOBALS $ */
export default [
  'webskedService',
  'thirdPartyIntegrationService',
  'fnService',
  WebskedTasksController,
]

const modalSize = [600, 580]

function WebskedTasksController(
  webskedService,
  thirdPartyIntegrationService,
  fnService
) {
  this.$onInit = () => {
    this.story = this.storyObj
    fetchTasks()
  }

  this.hasStoryId = () => !!this.storyObj._id

  const fetchTasks = () => {
    // TODO GET FROM INITIAL LOAD
    if (window.org_settings.disableWebskedIntegration || !this.story._id) {
      return
    }

    webskedService.getWebskedTasks().then((wst) => {
      this.tasks = fnService.at('data.results')(wst)
    })
  }

  this.openWebsked = () => {
    if (!this.story) {
      return
    }
    window.open(`/websked/#/story/${this.story._id}`, `_blank`)
  }

  this.newTask = () => {
    thirdPartyIntegrationService(
      `websked/#/task-form?storyID=${this.story._id}`,
      ['esc'],
      modalSize
    )
      .then((data) => fetchTasks())
      .catch(console.warn)
  }

  this.taskUrl = (task) => `websked/#/tasks/task/${task.id}`
}
